export const dateToDayMonthYearFormatted = (date) => {
  const dateTime = date.toString().split(' ')
  const newDate = dateTime[0]
  return newDate
}

export const dateToYearMonthDay = (date) => {
  const dateTime = date.toString().split(' ')
  const newDate = dateTime[0].split('/')

  return `${newDate[2]}-${newDate[1]}-${newDate[0]}`
}

export const dateToDayMonthYear = (date) => {
  const newDate = new Date(date)

  const month = newDate.getMonth() + 1
  const day = newDate.getDate()
  const year = newDate.getFullYear().toString().substr(-2)

  return `${day}/${month}/${year}`
}

export const dateToDayMonthYearAndHour = (date) => {
  if (!date) return null

  const newDate = new Date(date)

  const day = String(newDate.getDate()).padStart(2, '0')
  const month = String(newDate.getMonth() + 1).padStart(2, '0')
  const year = newDate.getFullYear()
  const hour = String(newDate.getHours()).padStart(2, '0')
  const minutes = String(newDate.getMinutes()).padStart(2, '0')

  return `${day}/${month}/${year} ${hour}:${minutes}`
}

// Función para convertir fecha del formato "DD/MM/YYYY HH:mm:ss" a "YYYY-MM-DD"
export const formatDateForInput = (dateString) => {
  if (!dateString) return ''

  try {
    // Si la fecha ya está en formato YYYY-MM-DD, la devolvemos tal como está
    if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
      return dateString
    }

    // Si la fecha está en formato "DD/MM/YYYY HH:mm:ss"
    if (dateString.includes('/')) {
      const [datePart] = dateString.split(' ') // Separar fecha de hora
      const [day, month, year] = datePart.split('/') // Dividir DD/MM/YYYY
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    }

    // Si es otro formato, intentar parsearlo sin conversión UTC
    const date = new Date(dateString)
    if (!isNaN(date.getTime())) {
      // Usar métodos locales en lugar de toISOString para evitar offset de zona horaria
      const year = date.getFullYear()
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const day = date.getDate().toString().padStart(2, '0')
      return `${year}-${month}-${day}`
    }

    return ''
  } catch (error) {
    console.error('Error formatting date:', error)
    return ''
  }
}
